import { ARC_ENVIRONMENT } from './arc-env';
const ARC_MAIL_FROM_NAMES = {
  dev: 'Arc Admin Development',
  staging: 'Arc Admin Staging',
  prod: 'Arc Admin'
};
export const ARC_MAIL_FROM_ADDRESS = `${ARC_MAIL_FROM_NAMES[ARC_ENVIRONMENT] || 'Arc Admin'} <admin@mail.avbarc.com>`;